var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.conditionsPerGroup, function (conditionsInGroup, group) {
    return _c('div', [group === Object.keys(_vm.conditionsPerGroup)[0] ? _c('strong', [_vm._v("Als")]) : _c('strong', [_vm._v("Of als")]), _c('table', {
      staticClass: "table-borderless table-sm"
    }, [_vm._m(0, true), _vm._l(conditionsInGroup, function (condition) {
      return _c('tr', [_c('td', [_vm._v(" " + _vm._s(condition.condition_class_display_name) + " ")]), _c('td', [condition.value !== null ? _c('span', [_vm._v(_vm._s(condition.operator))]) : _vm._e()]), _c('td', [condition.value !== null ? _c('span', [_vm._v(_vm._s(condition.value))]) : _vm._e()])]);
    })], 2)]);
  }), 0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "45%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "45%"
    }
  })]);

}]

export { render, staticRenderFns }